import Immutable from 'immutable'
import * as actionTypes from '../../actionTypes'

const ConnectionRecord = Immutable.Record({
    connected: false,
    connecting: false,
    error: false,
})

export class Connection extends ConnectionRecord
{
    // connected: boolean
    // connecting: boolean
    // error: boolean
}

const setConnectState = (state, connected, connecting) =>
    state
        .set('connected', connected)
        .set('connecting', connecting)

export default function (state = new Connection(), action) {
    switch (action.type) {
        case actionTypes.PAYMENT_TERMINAL_CONNECT:
            return setConnectState(state.set('error', false), false, true)
        case actionTypes.PAYMENT_TERMINAL_CONNECTED:
            return setConnectState(state.set('error', false), true, false)
        case actionTypes.PAYMENT_TERMINAL_DISCONNECT:
        case actionTypes.PAYMENT_TERMINAL_DISCONNECTED:
            return setConnectState(state, false, false)
        case actionTypes.PAYMENT_TERMINAL_ERROR:
            return state.set('error', true)
    }

    return state
}
